import { ReactElement, useState } from 'react';
import { HiChevronRight } from 'react-icons/hi2';
import GridHeader from 'components/GridHeader';
import GridContent from 'components/GridContent';
import SimpleRunRow from './SimpleRunRow';
import { RunGroup } from '../../../utils/runGrouping';

interface RunGroupSectionProps {
  group: RunGroup;
  config: any;
  session: any;
  sessions?: any[];
  invalidateRuns: () => void;
  defaultExpanded?: boolean;
}

export default function RunGroupSection({
  group,
  config,
  session,
  sessions,
  invalidateRuns,
  defaultExpanded = false,
}: RunGroupSectionProps): ReactElement {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="cr-mb-4 cr-rounded-lg cr-bg-white cr-shadow-lg">
      <div
        className="cr-flex cr-cursor-pointer cr-items-center cr-gap-2 cr-rounded-lg cr-px-4 cr-py-3
          cr-font-main cr-text-sm cr-font-semibold cr-text-blue-900 hover:cr-bg-cirrusBlue-25 md:cr-text-base"
        onClick={() => setExpanded(!expanded)}
      >
        <HiChevronRight
          className={`cr-h-4 cr-w-4 cr-transition-transform cr-duration-200 ${expanded ? 'cr-rotate-90' : ''}`}
        />
        <span>{group.label}</span>
        <span className="cr-font-normal cr-text-gray-500">
          {group.runs.length} {group.runs.length === 1 ? 'run' : 'runs'}
        </span>
      </div>
      {expanded && (
        <div className="cr-grid cr-grid-cols-[0.5fr_0.5fr_1.2fr_2.4fr_0.4fr] cr-px-2 cr-pb-2 cr-text-center">
          <GridHeader>
            <div>Health</div>
            <div>Run</div>
            <div>Date &amp; Time</div>
            <div>Description</div>
            <div></div>
          </GridHeader>
          <GridContent spanCount={5}>
            {group.runs.map((run: any) => (
              <SimpleRunRow
                key={run.id}
                run={run}
                config={config}
                session={session}
                sessions={sessions}
                invalidateRuns={invalidateRuns}
              />
            ))}
          </GridContent>
        </div>
      )}
    </div>
  );
}
